import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ResultImageGrid from 'root/components/ResultImageGrid';
import t from 'common/i18n';
import { useUI, useHomePageAssets } from '../../selectors';
import { POPULAR_CATEGORIES } from '../../data/consts';
import actions, { types as ats } from '../../actions';
import { THUMBNAIL_WIDTH_WHEN_PANEL_OPENED } from '../../../../common/consts';
import { GridBox, MainPageBox, CategoryHeader, CategorySubheader, CategoriesList, ListItem } from './HomePage.styles';

const CategoryLink = ({ category, handleSearch }) => {
  const navigateToCategory = useCallback(() => {
    handleSearch({ slug: category.slug });
  }, [handleSearch, category]);

  return (
    <ListItem onClick={navigateToCategory} data-test="pc-image">
      {category.name}
    </ListItem>
  );
};

const { [ats.RETRIEVE_HOME_PAGE_ASSETS]: retrieveHomePageAssetsAction } = actions.creators;

export default ({ handleSearch, onSelect }) => {
  const dispatch = useDispatch();
  const { items, assetsInProgress, selected } = useHomePageAssets();
  const { isFiltersPanelOpen } = useUI();

  const retrieveHomePageAssets = useCallback(() => dispatch(retrieveHomePageAssetsAction()), [dispatch]);

  useEffect(() => {
    retrieveHomePageAssets();
  }, [retrieveHomePageAssets]);

  return (
    <MainPageBox>
      <CategoryHeader>{t('unsplash.popular_categories')}</CategoryHeader>
      <CategorySubheader>{t('unsplash.editorial')}</CategorySubheader>
      <GridBox data-test="popular-categories-thumbnails">
        <ResultImageGrid
          images={isFiltersPanelOpen ? items.slice(0, 3) : items}
          selected={selected}
          selectionAction={onSelect}
          showProgressIndicator={assetsInProgress}
          isMultiple={false}
          itemWidth={isFiltersPanelOpen ? THUMBNAIL_WIDTH_WHEN_PANEL_OPENED : null}
          topBarRenderer={null}
        />
      </GridBox>
      <CategoriesList data-test="popular-categories-list">
        {POPULAR_CATEGORIES.map((c) => (
          <CategoryLink category={c} handleSearch={handleSearch} key={c.name} />
        ))}
      </CategoriesList>
    </MainPageBox>
  );
};
